export default __webpack_public_path__ + "static/media/Profile.44bd582e.svg";